import React,{useEffect} from 'react';
import { Container } from 'react-bootstrap';
import backgroundImage from "../../images/hamburg-hintergrund.jpg"


const ImpressumSection = () => {

      useEffect(() => {
            window.scrollTo(0, 0);
          }, []);
  return (
      <div>

     
    <div className="impressum-section" style={{ backgroundImage: `url(${backgroundImage})`, marginBottom:"100px" }}>
      <div className="impressum-overlay">
        <h1>Impressum</h1>
      </div>
      </div>
      <Container className="impressum-content" >
        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          <strong>Trans Rapido GmbH</strong><br />
          Beim Grünen Jäger 10<br />
          20359 Hamburg
        </p>
        <p>
          <strong>Vertreten durch:</strong><br />
          Ilir Fejzi
        </p>
        <p>
          <strong>Kontakt:</strong><br />
          Telefon: 0172 45 05 460<br />
          E-Mail: info@rapido-facility.de
        </p>
        <p>
          <strong>Registereintrag:</strong><br />
          Registergericht: Amtsgericht Hamburg<br />
          HRB-Nr. 144775
        </p>
        <p>
          <strong>Umsatzsteuer-ID:</strong><br />
          Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: 46/764/02875
        </p>
        <p>
          <strong>Aufsichtsbehörde:</strong><br />
          Finanzamt Hamburg-Hansa
        </p>
        <h3>Haftung für Inhalte</h3>
        <p>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        </p>
        <h3>Urheberrecht</h3>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors. Sollten Sie auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </p>
        <h3>Datenschutz</h3>
        <p>
          Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
          Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
          Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.
        </p>
      </Container>
    </div>
    
  );
};

export default ImpressumSection;
